<template>
  <div class="treeselect-custom">
    <div class="treeselect-custom__label">
      Commodity
    </div>
    <treeselect
      class="treeselect-custom__treeselect"
      placeholder="Commodity"
      v-model="internalValue"
      :options="choices"
      :multiple="multiple"
      :disable-branch-nodes="true"
      :limit="1"
      :search-nested="true"
      :always-open="false"
      :open-on-focus="true"
      :open-on-click="false"
      value-format="object"
      value-consists-of="LEAF_PRIORITY">
      <template #before-list v-if="toggleAll">
        <!-- toggle all/none selector, treeselect version -->
        <treeselect-toggle-all-selector
          @select-all="handleTreeselectSelectAll"
          @select-none="handleTreeselectSelectNone" />
      </template>
    </treeselect>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import TreeselectToggleAllSelector from './TreeselectToggleAllSelector'
import cloneDeep from 'lodash-es/cloneDeep'


export default {
  name: 'treeselect-custom',

  components: {
    Treeselect,
    TreeselectToggleAllSelector,
  },

  props: {
    choices: {
      type: Array,
      default: () => ([]),
    },

    toggleAll: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      internalValue: [],
      multiple: true,
    };
  },

  mounted() {
    this.$nextTick(() => {
      // hack to initialize treeselect correctly, otherwise you'll receive:
      // "Invalid node id: undefined", "Cannot read property 'isDisabled' of null"
      this.multiple = false;
    });
  },

  methods: {
    handleTreeselectSelectAll() {
      let subItemChoices = [];
      this.choices.forEach(item => {
        subItemChoices = subItemChoices.concat(cloneDeep(item.children));
      });

      this.internalValue = subItemChoices;
    },

    handleTreeselectSelectNone() {
      this.internalValue = [];
    },
  },

  watch: {
    internalValue() {
      this.$emit('input', this.internalValue);
    },

  },
}
</script>

<style scoped lang="scss">
  .treeselect-custom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;;

    &__label {

    }

    &__treeselect {
      flex: 0 0 75%;
    }
  }
</style>
